<template>
    <Modal
            v-model="_value"
            width="400"
            title="增加设备维修记录"
            @on-visible-change="visibleChange"
            ok-text="确认"
            @on-ok="onOk">
        <div style="position:relative;">
            <Form ref="maintainDeviceRecordRef" :model="maintainDeviceRecord" :label-width="80">
                <FormItem prop="content" label="主机号">
                    <Select v-model="selectDevice">
                        <Option v-for="item in devices" :value="item.terminalNum" :key="item.terminalNum">{{item.terminalNum+'('+ (item.positioningDeviceModel == null ? '无' : item.positioningDeviceModel.name) +')'}}</Option>
                    </Select>
                </FormItem>
                <FormItem label="操作">
                    <Checkbox v-model="maintainDeviceRecord.changeDevice"><span>更换设备主机</span></Checkbox>
                    <Checkbox v-model="maintainDeviceRecord.changeSim"><span>更换SIM卡</span></Checkbox>
                    <Checkbox :disabled="maintainDeviceRecord.changeDevice || maintainDeviceRecord.changeSim"
                              v-model="maintainDeviceRecord.removeDevice"><span>拆除设备</span></Checkbox>
                </FormItem>
                <FormItem v-if="maintainDeviceRecord.changeSim" prop="newTerminalNum" label="新设备主机号">
                    <Input v-model="maintainDeviceRecord.newTerminalNum"></Input>
                </FormItem>
                <FormItem v-if="maintainDeviceRecord.changeDevice" prop="newFactoryTerminalNum" label="新设备出厂主机号">
                    <Input v-model="maintainDeviceRecord.newFactoryTerminalNum"></Input>
                </FormItem>
                <FormItem v-if="maintainDeviceRecord.changeDevice" prop="newEncryptionchipnumber" label="设备芯片码">
                    <Input v-model="maintainDeviceRecord.newEncryptionchipnumber"></Input>
                </FormItem>
                <FormItem v-if="maintainDeviceRecord.changeDevice" prop="newPositioningDeviceModelId" label="新设备型号">
<!--                    <Input v-model="maintainDeviceRecord.newPositioningDeviceModel"></Input>-->
                    <Select v-model="maintainDeviceRecord.newPositioningDeviceModelId">
                        <Option v-for="item in PositioningDeviceModellist" :value="item.val" :key="item.val">{{item.name}}</Option>
                    </Select>
                </FormItem>
                <FormItem v-if="maintainDeviceRecord.removeDevice">
                    <Checkbox v-model="maintainDeviceRecord.deviceRecycle"><span>拆除设备是否可使用</span></Checkbox>
                </FormItem>
            </Form>
            <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="dataLoading">
                <Spin size="large"></Spin>
                <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
            </div>
        </div>
    </Modal>
</template>

<script>
    import Vue from 'vue';
    import {mapActions} from 'vuex'
    import store from '@/store'
    import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"
    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
    } from 'vant'

    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast);


    export default {
        name: "maintain-order-add-maintain-device-record-modal",
        props: {
            value: {
                type: Boolean,
                default: false
            },
            initValue: null
        },
        data(){
            return{
           PositioningDeviceModellist:[
                    // {name: 'BSJ-A6-BD', val: 1},
                    // {name: 'BSJ-GF03', val: 2},
                    // {name: 'BSJ-M11', val: 3},
                    // {name: 'K5', val: 4},
                    // {name: 'D5X', val: 5},
                    // {name: 'G-3G', val: 6},
                    // {name: 'D5X-HDD', val: 7},
                    // {name: 'D5X-XR', val: 8},
                    // {name: 'BSJ-GF06', val: 9},
                    // {name: 'BSJ-RM01', val: 10},
                    // {name: 'HIK-A3', val: 11},
                    // {name: 'HIK-A3L', val: 12},
                    // {name: 'BSJ-A6L', val: 13},
                    // {name: 'BSJ-A7', val: 14},
                ],


                devices: [],
                selectDevice: null,
                dataLoading: false,

                maintainDeviceRecord: {
                    terminalNum: null,
                    newTerminalNum: null,
                    newFactoryTerminalNum: null,
                    newEncryptionchipnumber: null,
                    newPositioningDeviceModelId: null,
                    changeDevice: false,
                    changeSim: false,
                    removeDevice: false,
                    deviceRecycle: false,
                    positioningDeviceInfoId: null,
                    positioningDeviceInfo: null,
                    result: null,
                    maintainOrderId: null,
                }
            }
        },
        methods: {
            ...mapActions([
                'MaintainOrderServ_AddMaintainDeviceRecord'
            ]),
            onOk() {
                this.$Modal.confirm({
                    title: '提示',
                    content: '<p>确认添加</p>',
                    onOk: () => {
                        this.maintainDeviceRecord.terminalNum = this.selectDevice

                        if (this.maintainDeviceRecord.changeDevice) {
                            if (this.maintainDeviceRecord.newFactoryTerminalNum ==null || this.maintainDeviceRecord.newPositioningDeviceModelId == null) {
                                this.$Message.error('请检查新设备出厂主机号或设备型号')
                                return;
                            }
                        }
                        if (this.maintainDeviceRecord.changeSim) {
                            if (this.maintainDeviceRecord.newTerminalNum ==null) {
                                this.$Message.error('请检查新设备主机号')
                                return;
                            }
                        }
                        if (this.maintainDeviceRecord.terminalNum.changeDevice || this.maintainDeviceRecord.terminalNum.changeSim) {
                            this.maintainDeviceRecord.terminalNum.deviceRecycle = false
                        }
                        store.dispatch('MaintainOrderServ_AddMaintainDeviceRecord', {
                            params: this.maintainDeviceRecord
                        }).then(() => {
                            this.$Message.success('添加成功')
                            this.$emit('on-success')
                        }).catch(err => {
                            this.$Message.error(err)
                            this.$emit('on-fail')
                        })
                    },
                    onCancel: () => {

                    }
                })
            },
            visibleChange(val) {
                if (val) {
                    this.selectDevice = null
                    this.maintainDeviceRecord.maintainOrderId = this._initValue
                    store.dispatch('MaintainOrderServ_GetCanMakeRecordDevices', {
                        params: {id: this._initValue},
                        urlparams: null
                    }).then(() => {
                        let devices = store.getters.get_MaintainOrder_GetCanMakeRecordDevicesResult
                        console.log(devices)
                        if (devices) {
                            this.devices = devices
                        }
                    }).catch(err => {
                        this.$Message.error(err)
                    })
                }
            }
        },
        computed: {
            _value: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val)
                    this.$emit('change', val)
                }
            },
            _initValue: {
                get() {
                    return this.initValue
                },
                set(val) {
                    // this.$emit('input', val);
                    // this.$emit('change', val);
                }
            }
        },
        mounted() {
            this.$nextTick(() => {

                store.dispatch('PositioningDeviceTypeServ_GetAll',{
                    params:null,
                    urlparams:null
                }).then(()=>{

                    if (store.getters.get_PositioningDeviceType_GetAllResult) {
                        store.getters.get_PositioningDeviceType_GetAllResult.forEach(item=>{
                            this.PositioningDeviceModellist.push({name: item.name, val: item.id},)
                        })
                    }
                }).catch(err=>{
                    console.log(err)
                })

            })
        }
    }
</script>

<style scoped>

</style>
